import styled, { keyframes } from 'styled-components'

import { EASE, duration, fadeIn } from '@styles/animations'
import { palette } from '@styles/tokens'

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

// A load that ends before this delay never shows a delayed loader, so it cannot flash.
const SHOW_DELAY = '300ms'

export const Container = styled.div<{ $delayed: boolean }>`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  animation: ${fadeIn} ${duration.enter} ${EASE} both;
  animation-delay: ${({ $delayed }) => ($delayed ? SHOW_DELAY : '0s')};
`

export const SpinnerSvg = styled.svg<{ $isPrimary: boolean }>`
  display: block;

  color: ${({ $isPrimary }) => ($isPrimary ? palette.primary : 'currentColor')};

  animation: ${spin} 900ms linear infinite;
`

export const TrackRing = styled.circle`
  fill: none;
  stroke: currentColor;
  opacity: 0.15;
`

export const CometTail = styled.circle`
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  opacity: 0.35;
`

export const CometHead = styled.circle`
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
`
